import React, { Component } from "react";

// import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
// import Pagination from "../Layout/Pagination";
import BoxJobPagination from "../Layout/BoxJobPagination";

import OAuthService from '../Auth/OAuthService';

import {
    Row, Col,
    Container,
    Button,
    // Table
    Alert,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Collapse, Card, CardHeader, CardBody
} from 'reactstrap';
import BoxOrder from "./BoxOrder";
import BoxJob from "./BoxJob";
import BatchReservation from "./BatchReservation";

import { humanize } from '../../box-helpers'
// import AssignmentIcon from '@material-ui/icons/Assignment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareSlidersVertical, faVideo, faChevronDown, faChevronRight, faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

class Dashboard extends Component {
    state = {
        user: false,
        box_orders: [],
        box_jobs: [],
        box_order_rows: [],
        batch_reservations: [],
        confirmation_message: "",
        errors: false,
        batchReservationSuccess: null,
        showHelpModal: false,
        showVideo: true
    }

    toggleHelpModal = () => {
        this.setState(prevState => ({ showHelpModal: !prevState.showHelpModal }));
    }

    toggleVideo = () => {
        this.setState(prevState => {
            const newShowVideo = !prevState.showVideo;
            localStorage.setItem('dashboardShowVideo', JSON.stringify(newShowVideo));
            return { showVideo: newShowVideo };
        });
    }
    constructor(props){
        super(props);
        this.os = new OAuthService();
    }

    componentDidMount = () => {
        // Check for video visibility preference
        const savedShowVideo = localStorage.getItem('dashboardShowVideo');
        if (savedShowVideo !== null) {
            try {
                this.setState({ showVideo: JSON.parse(savedShowVideo) });
            } catch (e) {
                console.log('Error parsing video preference', e);
            }
        }

        // Check for batch reservation success message
        const batchSuccessData = localStorage.getItem('batchReservationSuccess');
        if (batchSuccessData) {
            try {
                const successData = JSON.parse(batchSuccessData);
                this.setState({ batchReservationSuccess: successData });
                // Clear the localStorage after reading
                localStorage.removeItem('batchReservationSuccess');
            } catch (e) {
                console.log('Error parsing batch reservation success data', e);
                localStorage.removeItem('batchReservationSuccess');
            }
        }

        let token = JSON.parse(localStorage.getItem("token"));
        this.os.getUserInfo(token).then((result) => {
            this.setState({
                user: result,
                // box_orders: result["box_orders"],
                // box_designs: result["box_designs"],
                // box_uv_designs: result["box_uv_designs"]
            })
        }).catch((error) => {
            console.log(error);
            this.setState({
                // box_orders: [],
                // box_designs: [],
                // box_uv_designs: []
            })
        })

        // this.os.getBoxJobs(token).then((result) => {
        //     // console.log("box_jobs", result);
        //     this.setState({
        //         box_jobs: result["box_jobs"],
        //         // box_designs: result["box_designs"],
        //         // box_uv_designs: result["box_uv_designs"]
        //     })
        // }).catch((error) => {
        //     console.log(error);
        //     this.setState({
        //         box_jobs: [],
        //         // box_designs: [],
        //         // box_uv_designs: []
        //     })
        // })
        this.os.getBoxOrders(token).then((result) => {
            // console.log("box_orders", result);
            this.setState({
                box_orders: result["box_orders"],
                // box_designs: result["box_designs"],
                // box_uv_designs: result["box_uv_designs"]
            })
        }).catch((error) => {
            console.log(error);
            this.setState({
                box_orders: [],
                // box_designs: [],
                // box_uv_designs: []
            })
        })

        this.os.getBoxConfigurationBatchReservations(token).then((result) => {
            this.setState({
                batch_reservations: result["box_configuration_batch_reservations"] || []
            })
        }).catch((error) => {
            console.log(error);
            this.setState({
                batch_reservations: []
            })
        })

        // this.setOrderRows();

    }

    // resendConfirmation =() => {
    //     let token = JSON.parse(localStorage.getItem("token"));
    //     this.os.resendConfirmation(token).then((result) => {
    //         this.setState({confirmation_message: result['message']})
    //     }).catch((error) => {
    //         console.log(error);
    //     })
    // }

    orderRows = () => {
        let orderRows = this.state.box_orders.map( key => {
            return <BoxOrder key={key.id} order={key}></BoxOrder>
        })
        return orderRows;
    }

    boxJobRows = () => {
        let boxJobRows = this.state.box_jobs.map( key => {
            return <BoxJob key={key.id} box_job={key}></BoxJob>
        })
        return boxJobRows;
    }

    batchReservationRows = () => {
        return this.state.batch_reservations.map(batch => {
            return <BatchReservation key={batch.id} batch={batch} />
        });
    }

    // Pending Orders - No order available (Awaiting Order)
    getPendingBatchReservations = () => {
        return this.state.batch_reservations.filter(batch => !batch.order);
    }

    // Confirmed Orders - Order exists and status != shipped
    getConfirmedBatchReservations = () => {
        return this.state.batch_reservations.filter(batch =>
            batch.order && batch.order.status !== 'shipped'
        );
    }

    // Completed Orders - Order exists and status == shipped
    getCompletedBatchReservations = () => {
        return this.state.batch_reservations.filter(batch =>
            batch.order && batch.order.status === 'shipped'
        );
    }

    handleBatchDelete = (batchId) => {
        // Remove the deleted batch from state
        this.setState(prevState => ({
            batch_reservations: prevState.batch_reservations.filter(batch => batch.id !== batchId)
        }));
    }

    refreshBatchReservations = () => {
        // Refresh batch reservation data after box job actions
        let token = JSON.parse(localStorage.getItem("token"));
        this.os.getBoxConfigurationBatchReservations(token).then((result) => {
            this.setState({
                batch_reservations: result["box_configuration_batch_reservations"] || []
            })
        }).catch((error) => {
            console.log(error);
            this.setState({
                batch_reservations: []
            })
        })
    }

    sendConfirmation =() => {

        var body_params = new URLSearchParams();
        body_params.append("box_customer[email]", this.state.user.email);

        let token = JSON.parse(localStorage.getItem("client_token"));
        fetch(process.env.REACT_APP_API_URL + '/api/v4/confirmation', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ box_customer: {email: this.state.user.email} })
        })
        .then(response => response.json())
        .then(data => {
            if(data["errors"]){
                // console.log('result error: ',data["errors"]);
                let errors = Object.keys(data["errors"]).map(key => {
                    let human_key = humanize(key);
                    return  human_key + " " + data["errors"][key];
                })

                this.setState({ confirmation_message: errors, errors: errors })
            } else {
                this.setState({ confirmation_message: data.message })
            }

            return data;
        })
        .catch((error) => {

            console.log('errors', error)

            this.setState({confirmation_message: error, errors: true})
            return error;
        });

    }

    render() {
        return (
            <div>
                <Container fluid>
                    <Alert color={ this.state.errors ? "danger" : "success" } isOpen={ this.state.confirmation_message ? true : false} className="text-center mx-4">
                        { this.state.confirmation_message }
                    </Alert>

                    <Alert color="danger" isOpen={ !this.state.confirmation_message && this.state.user && !this.state.user.confirmed_at ? true : false} className="text-center mx-4">
                        Please confirm your email, {  this.state.user.email }. Check your Spam folder if you don't see it.
                        Orders will not show until your account is confirmed.
                        <Button color="primary" className="btn btn-sm mx-3" onClick={this.sendConfirmation} >Resend Confirmation</Button>
                    </Alert>

                    {/* Video Tutorial Section */}
                    <Row className="mx-2 mb-3">
                        <Col>
                            <Card>
                                <CardHeader
                                    onClick={this.toggleVideo}
                                    style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                                    className="d-flex align-items-center justify-content-between py-2"
                                >
                                    <div>
                                        <FontAwesomeIcon
                                            icon={this.state.showVideo ? faChevronDown : faChevronRight}
                                            className="mr-2"
                                        />
                                        <FontAwesomeIcon icon={faVideo} className="mr-2 text-danger" />
                                        <strong>Watch: How to Use Box Job Templates</strong>
                                        <span className="ml-2 text-muted" style={{ fontSize: '0.85rem' }}>
                                            {this.state.showVideo ? 'Click to minimize' : 'Click to expand'}
                                        </span>
                                    </div>
                                    <div>
                                        <a href="https://www.taydaelectronics.com/enclosure-modification-ordering-guide-v1" target="_blank" rel="noopener noreferrer">
                                            Ordering Guide <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="sm" />
                                        </a>
                                    </div>
                                </CardHeader>
                                <Collapse isOpen={this.state.showVideo}>
                                    <CardBody className="text-center p-3">
                                        <div className="embed-responsive embed-responsive-16by9" style={{ maxWidth: '800px', margin: '0 auto' }}>
                                            <iframe
                                                className="embed-responsive-item"
                                                src="https://www.youtube-nocookie.com/embed/x1OJzMbC-ps?si=dcoz-67e8Ao8MJbt"
                                                title="YouTube video player"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                referrerPolicy="strict-origin-when-cross-origin"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </CardBody>
                                </Collapse>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="col">
                            <Row className="mb-2">
                                <Col className="col" lg={12} md={12} sm={12} xs={12}>
                                    <Alert color="secondary" className="mb-1">
                                        <h5 className="demarginify">
                                            <FontAwesomeIcon icon={faSquareSlidersVertical} />  How To Use Box Job Templates
                                            <Button color="info" size="sm" className="ml-3" onClick={this.toggleHelpModal}>
                                                <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
                                            </Button>
                                        </h5>
                                        <Row className="mt-2">
                                            <Col md={4}>
                                                <h5 className="text-default">Step 1: <span className="text-primary">Design</span></h5>
                                                <ol className="mb-0 pl-3 ml-2 pt-1" style={{ fontSize: '0.9rem' }}>
                                                    <li>Create <a href="/my-drill-templates">Drill Templates</a> for your enclosures.</li>
                                                    <li>Upload <a href="/my-uv-print-templates">UV Design Templates</a> for custom graphics.</li>
                                                    <li>Go to <a href="/my-box-configurations">Box Job Templates</a> and click <strong>"+ New Box Job Template"</strong> to combine your designs.</li>
                                                </ol>
                                            </Col>
                                            <Col md={4}>
                                                <h5 className="text-default">Step 2: <span className="text-success">Order</span></h5>
                                                <ol className="mb-0 pl-3 ml-2 pt-1" style={{ fontSize: '0.9rem' }}>
                                                    <li>Click the green <strong>"Create Order"</strong> button on the <a href="/my-box-configurations">Box Job Templates</a> page.</li>
                                                    <li>Select up to 10 templates and set quantities.</li>
                                                    <li>Review products, then click <strong>"Reserve Batch & Add to Cart"</strong>.</li>
                                                    <li>Complete your purchase on <a href="https://www.taydaelectronics.com" target="_blank" rel="noopener noreferrer">TaydaElectronics.com</a>.</li>
                                                </ol>
                                            </Col>
                                            <Col md={4}>
                                                <h5 className="text-default">Step 3: <span className="text-warning">Track</span></h5>
                                                <ol className="mb-0 pl-3 ml-2 pt-1" style={{ fontSize: '0.9rem' }}>
                                                    <li>Your order will appear in <strong>"Box Job Template Orders"</strong> below within 15-20 minutes.</li>
                                                    <li>Box Jobs are automatically created when your order is received.</li>
                                                    <li>Track production status and messages here on your Dashboard.</li>
                                                </ol>
                                            </Col>
                                        </Row>
                                        {!this.state.batchReservationSuccess && (
                                            <Alert color="primary" className="mt-2 mb-0">
                                                After placing order, please always follow up your order status from here.
                                                If we are able to find any irregularity with any of template before it is done, we will post a message in here. <br />
                                                We won't send an email because many can end up in junk mail.
                                                <b>If you don't see your order here (after waiting for a while), please contact us.</b>
                                            </Alert>
                                        )}
                                    </Alert>
                                </Col>

                                {/* Help Modal */}
                                <Modal isOpen={this.state.showHelpModal} toggle={this.toggleHelpModal} size="lg" style={{ top: '20%' }}>
                                    <ModalHeader toggle={this.toggleHelpModal}>
                                        <FontAwesomeIcon icon={faSquareSlidersVertical} className="mr-2" />
                                        About Box Job Templates
                                    </ModalHeader>
                                    <ModalBody>
                                        <Alert color="success" className="mb-0">
                                            <div>
                                                <ol className="mb-0">
                                                    <li>Box Job Templates are reusable configurations for Box Jobs and services.</li>
                                                    <li>Box Job Templates allow you to set Drill and UV services for each enclosure type that can be easily ordered or reserved through TaydaElectronics.com.</li>
                                                    <li>You can create, edit, and manage your templates to suit your Box Job orders.</li>
                                                    <li>Click on "+ New Box Job Template" button to create a new template.</li>
                                                    <li>Click on "Create Order" button to assign Box Job Templates to an order.</li>
                                                </ol>
                                            </div>
                                        </Alert>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="secondary" onClick={this.toggleHelpModal}>Close</Button>
                                    </ModalFooter>
                                </Modal>
                            </Row>
                            <div className="px-3 pt-2">
                                {this.state.batchReservationSuccess && (
                                    <Alert color="info" className="mx-4" toggle={() => this.setState({ batchReservationSuccess: null })}>
                                        <h5 className="alert-heading">Box Template Order Successfully Reserved!</h5>
                                        <p className="mb-2">{this.state.batchReservationSuccess.message}</p>
                                        <p className="mb-0">
                                            <strong>Next Steps:</strong>
                                            <ol className="mb-0 mt-1">
                                                <li>Complete your purchase on <a href="https://www.taydaelectronics.com" target="_blank" rel="noopener noreferrer">TaydaElectronics.com</a> (cart should be open in a new tab)</li>
                                                <li>Your order will appear in the "Box Template Orders" section below within 15-20 minutes</li>
                                                <li>Track your order status and any messages on this Dashboard</li>
                                            </ol>
                                        </p>
                                    </Alert>
                                )}
                                {this.state.batch_reservations && this.state.batch_reservations.length > 0 && (
                                    <div className="mb-4">
                                        <h3 className="mb-0">Box Template Orders</h3>
                                        <div className="text-small mb-2"><b>Orders created from the "Create Order" feature on the Box Job Templates page.</b></div>

                                        {/* Pending Orders - No order available */}
                                        {this.getPendingBatchReservations().length > 0 && (
                                            <div className="mb-3">
                                                <h5 className="text-default mb-1">Pending Orders</h5>
                                                <Row className="my-0 text-muted" style={{ fontSize: '0.9rem' }}>
                                                    <Col className="col" lg={3} md={5} sm={5} xs={5}>Templates</Col>
                                                    <Col className="col" lg={2} md={2} sm={2} xs={2}>Status</Col>
                                                    <Col className="col" lg={5} md={4} sm={2} xs={2}>Order</Col>
                                                    <Col className="col text-right" lg={2} md={2} sm={2} xs={2}>Created</Col>
                                                </Row>
                                                {this.getPendingBatchReservations().map(batch => (
                                                    <BatchReservation
                                                        key={batch.id}
                                                        batch={batch}
                                                        os={this.os}
                                                        onDelete={this.handleBatchDelete}
                                                        onBatchUpdate={this.refreshBatchReservations}
                                                    />
                                                ))}
                                            </div>
                                        )}

                                        {/* Received Orders - Order exists and status != shipped */}
                                        {this.getConfirmedBatchReservations().length > 0 && (
                                            <div className="mb-3">
                                                <h5 className="text-default mb-1">Received Orders</h5>
                                                <Row className="my-0 text-muted" style={{ fontSize: '0.9rem' }}>
                                                    <Col className="col" lg={3} md={5} sm={5} xs={5}>Templates</Col>
                                                    <Col className="col" lg={2} md={2} sm={2} xs={2}>Status</Col>
                                                    <Col className="col" lg={5} md={4} sm={2} xs={2}>Order</Col>
                                                    <Col className="col text-right" lg={2} md={2} sm={2} xs={2}>Created</Col>
                                                </Row>
                                                {this.getConfirmedBatchReservations().map(batch => (
                                                    <BatchReservation
                                                        key={batch.id}
                                                        batch={batch}
                                                        batchType="received"
                                                        onBatchUpdate={this.refreshBatchReservations}
                                                    />
                                                ))}
                                            </div>
                                        )}

                                        {/* Completed Orders - Order exists and status == shipped */}
                                        {this.getCompletedBatchReservations().length > 0 && (
                                            <div className="mb-3">
                                                <h5 className="text-default mb-1">Completed Orders</h5>
                                                <Row className="my-0 text-muted" style={{ fontSize: '0.9rem' }}>
                                                    <Col className="col" lg={3} md={5} sm={5} xs={5}>Templates</Col>
                                                    <Col className="col" lg={2} md={2} sm={2} xs={2}>Status</Col>
                                                    <Col className="col" lg={5} md={4} sm={2} xs={2}>Order</Col>
                                                    <Col className="col text-right" lg={2} md={2} sm={2} xs={2}>Created</Col>
                                                </Row>
                                                {this.getCompletedBatchReservations().map(batch => (
                                                    <BatchReservation
                                                        key={batch.id}
                                                        batch={batch}
                                                        onBatchUpdate={this.refreshBatchReservations}
                                                    />
                                                ))}
                                            </div>
                                        )}

                                        <hr style={{border: '2px solid rgba(0,0,0,.1)'}} className="mt-3"/>
                                    </div>
                                )}

                                <h4 className="mb-0">Available Orders ( Old System )</h4>
                                <div className="text-small mb-2"><b>(PLEASE WAIT AT LEAST 15 MINUTES AFTER PLACING ORDER TO SEE YOUR ORDER NUMBER BELOW)</b></div>

                                { this.state.box_orders && (
                                    <div>
                                        <Row className="my-2">
                                            <Col className="col" md={3}>Order #</Col>
                                            <Col className="col" md={4}>Products</Col>
                                            <Col className="col" md={2}>Status</Col>
                                        </Row>

                                        { this.orderRows() }
                                    </div>
                                )}
                                <Alert color="secondary" isOpen={!this.state.box_orders ? true : false}>
                                    {!this.state.user.confirmed_at && (
                                        <h5 className="danger">Your orders will not appear in this tool until you confirm your email.</h5>
                                    )}
                                    <h5><a href="https://www.taydaelectronics.com/hardware/enclosures.html" >Order An Encosure Product</a></h5>
                                </Alert>


                                {/* { this.state.box_jobs && this.state.box_jobs.length > 0 && (
                                    <div>
                                        <hr style={{border: '2px solid rgba(0,0,0,.1)'}}/>
                                        <h4>Box Jobs</h4>
                                        <Row className="my-2">
                                            <Col className="col" md={1}>JobID</Col>
                                            <Col className="col" md={2}>Order #</Col>
                                            <Col className="col" md={1}>Qty</Col>
                                            <Col className="col" md={4}>Enclosure</Col>
                                            <Col className="col" md={3}>Status</Col>
                                            <Col className="col text-right" md={1}>Created</Col>
                                        </Row>

                                        { this.boxJobRows() }
                                    </div>
                                )} */}

                                <BoxJobPagination os={this.os} />

                            </div>
                        </Col>
                        {/*
                        <Col className="col" md={5}>
                            <div className="mb-2 text-center">
                                <h3>Box Templates</h3>
                            </div>
                            <div>
                                <Alert color="success" className="text-left">
                                    <div className="text-success">
                                        <h5>Latest Features!</h5>
                                        <b>Easy Shapes</b> - You can easily create Rectangles and Triangle shapes with the new Shapes feature in Drill Templates.
                                        <br />
                                        <b>Lines</b> - You can create rectangular drill patterns and any other shapes using Lines with the drill tool.
                                        For an example template for lines. <a href="/box-designs/new?public_key=UzlXTFdzVVBsRnh5WHU4OFdNTCs0UT09Cg==">Click Here</a>
                                        <br />
                                        <b>Enclosure Lids</b> - You can UV print and drill on the lids of enclosure if you can order the service for enclosure lids.
                                    </div>
                                </Alert>
                                <h5 className="float-left">My Drill Templates</h5>
                                <a className="btn btn-sm btn-outline-primary float-right" href="/box-designs/new">+ New Drill Template</a>
                                <div style={{ clear: 'both'}}></div>
                                <Pagination
                                    page_size_key={"_boxDesignsPageSize"}
                                    url={process.env.REACT_APP_API_URL + '/api/v4/box_designs'}
                                    data_attr={"box_designs"}
                                    redirect_to={"box-designs"}
                                    show_archived={false}
                                />
                            </div>
                            <hr style={{border: '2px solid rgba(0,0,0,.1)'}}/>
                            <div>
                                <h5 className="float-left">My UV Design Templates</h5>
                                <a className="btn btn-sm btn-outline-primary float-right" href="/box-uv-designs/new">+ New UV Design Template</a>
                                <div style={{ clear: 'both'}}></div>
                                <Pagination
                                    page_size_key={"_boxUVDesignsPageSize"}
                                    url={process.env.REACT_APP_API_URL + '/api/v4/box_uv_designs'}
                                    data_attr={"box_uv_designs"}
                                    redirect_to={"box-uv-designs"}
                                    show_archived={false}
                                    show_incomplete={true}
                                />
                            </div>
                            <hr style={{border: '2px solid rgba(0,0,0,.1)'}}/>
                            <div>
                                <h5 className="float-left">My Faceplate Templates</h5>
                                <a className="btn btn-sm btn-outline-primary float-right" href="/faceplate-designs/new">+ New Faceplate Template</a>
                                <div style={{ clear: 'both'}}></div>
                                <Pagination
                                    page_size_key={"_flatDesignsPageSize"}
                                    url={process.env.REACT_APP_API_URL + '/api/v4/flat_designs'}
                                    data_attr={"flat_designs"}
                                    redirect_to={"faceplate-designs"}
                                    show_archived={false}
                                />
                            </div>
                            <hr style={{border: '2px solid rgba(0,0,0,.1)'}}/>
                            <div className="text-right">
                                <a href="/archive">View Archive Box Templates</a>
                            </div>
                            <Alert style={{marginTop: '20px'}} color="dark" isOpen={ true }>
                                <h5>
                                    Order high quality enclosures, custom drill and UV services at <br />
                                    <a href="https://www.taydaelectronics.com/hardware/enclosures.html" target="_blank" rel="noopener noreferrer">Tayda Electronics.com</a>
                                </h5>
                            </Alert>

                        </Col>
                        */}
                    </Row>
                </Container>
                <Footer />
            </div>
        )
    }
}
export default Dashboard;